(() => {
  const initialize = (root) => {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const copy = JSON.parse(root.querySelector('[data-product-copy]').textContent);
    const variants = JSON.parse(root.querySelector('[data-product-variants]').textContent);
    const form = root.querySelector('.ip-form');
    const quantity = form.querySelector('[name="quantity"]');
    const showMedia = (id) => {
      if (!id || !root.querySelector(`[data-media-id="${id}"]`)) return;
      root.querySelectorAll('[data-media-id]').forEach(item => {
        item.classList.toggle('is-active', item.dataset.mediaId === String(id));
        if (item.dataset.mediaId !== String(id)) item.querySelectorAll('video').forEach(video => video.pause());
      });
      root.querySelectorAll('[data-show-media]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.showMedia === String(id))));
    };
    const update = (id) => {
      const variant = variants.find(item => String(item.id) === String(id));
      if (!variant) return;
      root.querySelector('[data-price-now]').textContent = variant.price;
      root.querySelector('[data-price-was]').textContent = variant.compare;
      root.querySelector('[data-price-off]').textContent = variant.discount;
      root.querySelector('[data-price-block]').classList.toggle('price--on-sale', Boolean(variant.compare));
      const title = variant.title === 'Default Title' ? copy.productTitle : variant.title;
      root.querySelector('[data-selected-title]').textContent = title;
      root.querySelector('[data-mobile-version]').textContent = variant.title === 'Default Title' ? '' : title;
      root.querySelector('[data-mobile-price]').textContent = variant.price;
      root.querySelector('[data-stock-text]').textContent = variant.available ? copy.madeToOrder : copy.soldOut;
      root.querySelectorAll('[data-purchase-button]').forEach(button => {
        button.disabled = !variant.available;
        button.textContent = !variant.available ? copy.soldOut : button.classList.contains('ip-buy') ? copy.buy : copy.add;
      });
      const min = variant.minimum || 1, increment = variant.increment || 1;
      quantity.min = String(min);
      quantity.step = String(increment);
      if (variant.maximum) quantity.max = String(variant.maximum); else quantity.removeAttribute('max');
      let value = min + Math.max(0, Math.ceil((Number(quantity.value || min) - min) / increment)) * increment;
      if (variant.maximum) value = Math.min(value, variant.maximum);
      quantity.value = String(value);
      showMedia(variant.mediaId);
    };

    const picker = form.querySelector('[data-option-picker]');
    const variantSelect = form.querySelector('[data-variant-select]');
    if (picker && variantSelect) {
      const selectors = Array.from(picker.querySelectorAll('[data-option-index]'));
      const refreshOptions = () => selectors.forEach((selector, index) => {
        Array.from(selector.options).forEach(option => {
          option.disabled = !variants.some(variant => variant.options[index] === option.value &&
            selectors.slice(0, index).every((prior, i) => variant.options[i] === prior.value));
        });
      });
      selectors.forEach((selector, changedIndex) => selector.addEventListener('change', () => {
        const values = selectors.map(select => select.value);
        let match = variants.find(variant => variant.options.every((value, i) => value === values[i]));
        if (!match) {
          const candidates = variants.filter(variant => values.slice(0, changedIndex + 1).every((value, i) => variant.options[i] === value));
          match = candidates.find(variant => variant.available) || candidates[0];
        }
        if (!match) return;
        selectors.forEach((select, i) => { select.value = match.options[i]; });
        variantSelect.value = String(match.id);
        refreshOptions();
        update(match.id);
      }));
      picker.hidden = false;
      form.querySelector('.ip-variant-fallback').hidden = true;
      refreshOptions();
    }
    root.querySelectorAll('[name="id"]').forEach(input => input.addEventListener('change', () => update(input.value)));
    root.querySelectorAll('[data-show-media]').forEach(button => button.addEventListener('click', () => showMedia(button.dataset.showMedia)));
    root.classList.add('is-ready');
    const selected = form.querySelector('[name="id"]:checked') || form.querySelector('[name="id"]');
    if (selected) update(selected.value);
  };
  const initializeAll = (scope) => scope.querySelectorAll('[data-ignition-product]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll(document)); else initializeAll(document);
  document.addEventListener('shopify:section:load', event => initializeAll(event.target));
})();
